import { render, staticRenderFns } from "./TotaldeConsumosDetail.vue?vue&type=template&id=2514c77a&scoped=true&"
import script from "./TotaldeConsumosDetail.vue?vue&type=script&lang=js&"
export * from "./TotaldeConsumosDetail.vue?vue&type=script&lang=js&"
import style0 from "./TotaldeConsumosDetail.vue?vue&type=style&index=0&id=2514c77a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514c77a",
  null
  
)

export default component.exports